<template>
  <div class="slider slider-boxed" :class="[myClass]" ref="slider">
    <div class="slider-window">
      <div class="slider-list" :style="{left: left+'px'}" ref="sliderList">
        <div class="slide" v-for="(slide, index) in slides" :class="{active: isSlideActive(index)}" :key="slide.id" ref="slides">
          <slot name="slide" :slide="slide"></slot>
        </div>
      </div>
    </div>
    <div class="container slider-bottom" ref="sliderBottom" :style="{opacity: sliderColumns < slides.length ? 1 : 0}">
      <template v-if="type==='slider'">
        <div class="slider-nav" >
          <button class="slider-prev" @click="goToPrev()"></button>
          <div class="slider-indicator">
            <div class="slider-indicator-inner"></div>
          </div>
          <button class="slider-next" @click="goToNext()"></button>
        </div>
        <ul class="slider-paginator hidden" v-if="type==='slider'">
          <li v-for="(slide, index) in slides" :key="slide.id" :class="{active: isSlideActive(index)}" :data-slider="index + 1" @click="clickPaginatorPoint(index)" />
        </ul>
      </template>
      <div class="slider-nav" v-else>
        <button class="slider-prev" @click="goToPrev()" :class="{inactive: selectedIndex === 0}"></button>
        <ul class="slider-paginator">
          <li v-for="(slide, index) in slides" :class="{active: isSlideActive(index)}" :key="slide.id" :data-slider="index + 1" @click="clickPaginatorPoint(index)" />
        </ul>
        <button class="slider-next" @click="goToNext()" :class="{inactive: selectedIndex === slides.length - 1}"></button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: "Slider",
  props: ['slides', 'type', 'myClass', 'cols'],
  created() {
    window.addEventListener("resize", _.debounce(this.sliderAfterResize, 100))
    window.addEventListener("swiped-left", this.goToNext)
    window.addEventListener("swiped-right", this.goToPrev)
  },
  data() {
    return {
      selectedIndex: 0,
      sliderColumns: 0,
      windowWidth: window.innerWidth,
      left: 0,
      timeoutID: null,
    }
  },
  mounted () {
    this.sliderResizer()
    this.clickPaginatorPoint(0)
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  destroyed() {
    clearTimeout(this.timeoutID)
  },
  methods: {
    isSlideActive(index) {
      return this.selectedIndex === index
    },
    sliderResizer () {
      let slideCols

      // How many slides are in a row?
      if (this.windowWidth > 768 && this.cols) {
        slideCols = this.cols - this.slides.length < 0 ? this.cols  : this.slides.length
      } else {
        slideCols = Math.floor(this.$refs.slider.clientWidth / this.$refs.slides[0].clientWidth)
      }
      this.sliderColumns = slideCols
    },
    sliderAfterResize () {
      this.sliderResizer()
      if(this.$refs.slides[this.selectedIndex]) {
        this.clickPaginatorPoint(this.selectedIndex)
      }
    },
    clickPaginatorPoint (index) {
      clearTimeout(this.timeoutID)
      let position = index + 1
      // Don't leave a blank space behind the slider - choose the last slider you can show
      if (this.slides.length - position + 1 < this.sliderColumns) {
        position = this.slides.length - this.sliderColumns + 1
      }

      // mySlider.querySelector('.slide:nth-child(' + this.currentSlide + ')').offsetLeft
      let newLeft = - this.$refs.slides[index].offsetLeft
        // - parseFloat(getComputedStyle(this.$refs.slides[index]).marginLeft)

      // Container slider
      if (this.windowWidth > 575 && this.cols) {
        newLeft += this.$refs.sliderBottom.getBoundingClientRect().left + 16
      } else if (this.windowWidth < 576 && this.cols) {
        newLeft += 16
      }

      this.left = newLeft
      this.selectedIndex = index
      let _this = this
      this.timeoutID = setTimeout(function () {
        if(_this.selectedIndex === _this.slides.length - 1) {
          return _this.clickPaginatorPoint(0)
        }
        return _this.clickPaginatorPoint(_this.selectedIndex + 1)
      }, 6000)
    },
    goToPrev () {
      this.clickPaginatorPoint(this.selectedIndex - 1 )
    },
    goToNext () {
      this.clickPaginatorPoint(this.selectedIndex + 1 )
    },
  }
}
</script>
